import React from 'react'
import '@google/model-viewer'
import { ScreenSectionItem } from 'mytours-read-common'

interface Props {
	sectionItem: ScreenSectionItem
}

const SectionMediaAr: React.FC<Props> = ({ sectionItem = {} }: Props) => {
	if (!sectionItem) {
		return null
	}
	const { glb, usdz, name } = sectionItem as any
	return (
		// @ts-ignore
		<model-viewer src={glb?.original_url} ios-src={usdz?.original_url} alt={name} ar={true} auto-rotate={true} />
	)
}

export default SectionMediaAr
